import { computed, onMounted, onUnmounted, ref } from 'vue';
import { usePublicPage } from './usePublicPage';

/**
 * [#e03fdbc2] Время и дата браузера на экранах телефонов. Пока страница не ожила, показывается
 * время из готового HTML, поэтому разметка совпадает, а настоящее время подставляется сразу после.
 */
const INTL = { en: 'en-GB', ru: 'ru-RU', uz: 'uz-UZ', es: 'es-ES' } as const;

// Браузеры часто не знают узбекский формат даты и показывают «M11 4, Wed», поэтому названия свои.
const UZ_DAYS = ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba'];
const UZ_MONTHS = ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun', 'iyul', 'avgust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'];

export function useNow() {
  const { locale, copy } = usePublicPage();
  const now = ref<Date | null>(null);
  let timer: ReturnType<typeof setInterval> | null = null;
  onMounted(() => {
    now.value = new Date();
    timer = setInterval(() => (now.value = new Date()), 15000);
  });
  onUnmounted(() => {
    if (timer) clearInterval(timer);
  });

  function formatTime(date: Date): string {
    return new Intl.DateTimeFormat(INTL[locale.value], { hour: '2-digit', minute: '2-digit', hour12: false }).format(date);
  }

  const time = computed(() => (now.value ? formatTime(now.value) : '9:41'));
  const date = computed(() => {
    if (!now.value) return copy.value.phone.home;
    if (locale.value === 'uz') {
      return `${UZ_DAYS[now.value.getDay()]}, ${now.value.getDate()}-${UZ_MONTHS[now.value.getMonth()]}`;
    }
    const text = new Intl.DateTimeFormat(INTL[locale.value], { weekday: 'long', day: 'numeric', month: 'long' }).format(now.value);
    return text.charAt(0).toUpperCase() + text.slice(1);
  });
  /** Время события «столько-то минут назад» для примеров уведомлений. */
  const minutesAgo = (minutes: number) => (now.value ? formatTime(new Date(now.value.getTime() - minutes * 60000)) : null);

  return { time, date, minutesAgo };
}
